module.exports = __webpack_public_path__ + "media/images/leaf-svgrepo-com-c96c5d068f3c5f40a9c8e578a8187750.svg";